export default __webpack_public_path__ + "static/media/search.4c4d5c2d.svg";